import icon from 'vue-svgicon';

icon.register({
    'bold/email-action-unread': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.888 5.832a.182.182 0 0 0-.2.039l-9.747 9.745a2.75 2.75 0 0 1-3.888 0L.31 5.871a.18.18 0 0 0-.2-.039A.182.182 0 0 0 0 6v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a.181.181 0 0 0-.112-.168z"/><path pid="1" d="M11.115 14.556a1.252 1.252 0 0 0 1.768 0l9.686-9.686a.5.5 0 0 0 .121-.511C22.58 4.03 22.274 4 22 4H2c-.275 0-.583.03-.691.359a.5.5 0 0 0 .121.511z"/>`,
    },
});
